import type { ReactNode } from 'react';
import React, { useMemo } from 'react';

type PermissionsContextValue = Record<string, never>;

const PermissionsContext = React.createContext<PermissionsContextValue | null>(
  null,
);

type PermissionsProviderProps = {
  children: ReactNode;
};

function PermissionsProvider({ children }: PermissionsProviderProps) {
  const contextValue = useMemo(() => ({}), []);
  return (
    <PermissionsContext.Provider value={contextValue}>
      {children}
    </PermissionsContext.Provider>
  );
}

PermissionsProvider.displayName = 'PermissionsProvider';
export { PermissionsContext, PermissionsProvider };
